import { Middleware } from "@reduxjs/toolkit";

// Auto-dismiss logic has been moved to the Notifications component
// to support pause-on-hover. This middleware is kept as a pass-through
// in case future notification side-effects are needed.
const notifications: Middleware = _store => next => action => {
  return next(action);
};

export default notifications;
